import React from "react";
import PropTypes from "prop-types";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Button, DotsGrid } from "@opendate-app/setlist";

const SortableNote = ({ id, title, sortable, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled: !sortable });

  const handle = sortable ? (
    <Button
      variant="tertiary"
      size="xs"
      icon={DotsGrid}
      aria-label={`Reorder ${title}`}
      className="sl-note-drag-handle"
      onClick={(e) => e.stopPropagation()}
      {...attributes}
      {...listeners}
    />
  ) : null;

  return children({
    handle,
    nodeProps: {
      ref: setNodeRef,
      style: { transform: CSS.Translate.toString(transform), transition },
    },
    draggingClassName: isDragging ? "sl-note-dragging" : "",
  });
};

SortableNote.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  sortable: PropTypes.bool.isRequired,
  children: PropTypes.func.isRequired,
};

export default SortableNote;
